import {FC} from 'react'

import {theme} from '@/theme/theme'

type CircleStrokeProps = {
  percentage: string | number
  circleColor?: string
  strokeColor?: string
  strokeWidth?: number
}

export const CircleStroke: FC<React.PropsWithChildren<CircleStrokeProps>> = ({
  percentage,
  circleColor = theme.palette.background.default,
  strokeColor = theme.palette.primary.main,
  strokeWidth = 2,
}) => (
  <>
    <svg viewBox="0 0 36 36">
      <path
        className="circle"
        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        className="stroke"
        strokeDasharray={`${percentage}, 100`}
        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
      />
    </svg>

    <style jsx>{`
      svg {
        display: block;
      }
      .circle {
        fill: none;
        stroke: ${circleColor};
        stroke-width: ${strokeWidth}px;
      }
      .stroke {
        fill: none;
        stroke: ${strokeColor};
        stroke-width: ${strokeWidth}px;
        stroke-linecap: round;
        animation: progress 1s ease-out forwards;
      }
      @keyframes progress {
        0% {
          stroke-dasharray: 0 100;
        }
      }
    `}</style>
  </>
)
